/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";

/** @module browser/modules/event-listener-object-support */
import { log } from '@codistica/core';
var eventListenerObjectSupport = {
  capture: null,
  passive: null
}; // DETECT EVENT LISTENER OBJECT ARGUMENT SUPPORT

try {
  var eventOptions = _Object$defineProperties({}, {
    capture: {
      /**
       * @description Event listener capture object mock.
       * @returns {undefined} Undefined.
       */
      get: function get() {
        eventListenerObjectSupport.capture = true;
        return undefined;
      }
    },
    passive: {
      /**
       * @description Event listener passive object mock.
       * @returns {undefined} Undefined.
       */
      get: function get() {
        eventListenerObjectSupport.passive = true;
        return undefined;
      }
    }
  });

  window.addEventListener('test', null, eventOptions);
  window.removeEventListener('test', null, eventOptions);
} catch (err) {
  log.error('eventListenerObjectSupport', err);
  eventListenerObjectSupport.capture = false;
  eventListenerObjectSupport.passive = false;
}

export { eventListenerObjectSupport };